<div class="login-page-wrapper" [class.with-marketing]="showMarketingContent">
    <div class="login-container" [class.two-column]="showMarketingContent">

        <!-- Marketing Content Section (Only for external visitors) -->
        <div class="marketing-section" *ngIf="showMarketingContent">
            <div class="marketing-content">

                <!-- Hero Section -->
                <div class="hero-section">
                    <h1 class="hero-headline">Scale Your Outreach.<br>Automate Your Growth.</h1>
                    <p class="hero-subheadline">
                        Connect your sequencer and CRM, see what your own outbound data says is
                        working, and act on it from one place.
                    </p>
                </div>

                <!-- Features Grid -->
                <div class="features-grid">
                    <div class="feature-card">
                        <div class="feature-icon">
                            <i class="pi pi-send"></i>
                        </div>
                        <div class="feature-content">
                            <h3 class="feature-title">Multi-Channel Campaigns</h3>
                            <p class="feature-description">
                                Build email and LinkedIn campaigns and start them in the
                                sequencer you already use.
                            </p>
                        </div>
                    </div>

                    <div class="feature-card">
                        <div class="feature-icon">
                            <i class="pi pi-chart-line"></i>
                        </div>
                        <div class="feature-content">
                            <h3 class="feature-title">AI-Powered Insights</h3>
                            <p class="feature-description">
                                Optimize messaging with pattern analysis.
                                Track performance as your campaigns sync.
                            </p>
                        </div>
                    </div>

                    <div class="feature-card">
                        <div class="feature-icon">
                            <i class="pi pi-link"></i>
                        </div>
                        <div class="feature-content">
                            <h3 class="feature-title">Smart Integration</h3>
                            <p class="feature-description">
                                Connect your favorite tools seamlessly.
                                Import prospects and manage leads effortlessly.
                            </p>
                        </div>
                    </div>

                    <div class="feature-card">
                        <div class="feature-icon">
                            <i class="pi pi-shield"></i>
                        </div>
                        <div class="feature-content">
                            <h3 class="feature-title">Enterprise Security</h3>
                            <p class="feature-description">                                
                                Role-based access control for your entire team.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Social Proof -->
                <div class="social-proof">
                    <p>Built for outbound sales teams</p>
                </div>

                <!-- CTA Buttons -->
                <div class="cta-buttons">
                    <button class="cta-primary" (click)="switchToSignUp()">
                        <span>Start Free Trial</span>
                        <i class="pi pi-arrow-right"></i>
                    </button>
                </div>

            </div>
        </div>

        <!-- Authentication Section -->
        <div class="auth-section">
            <div class="auth-container">
                <h3 class="gradient-title">Anchored Growth</h3>

                <!-- Terms and Conditions Section (Only visible during sign up) -->
                <div class="terms-section" [style.display]="showTermsSection ? 'block' : 'none'">
                    <div class="terms-checkbox-container">
                        <p-checkbox
                            [(ngModel)]="termsAccepted"
                            [binary]="true"
                            inputId="termsCheckbox"
                            (onChange)="onTermsAcceptanceChange($event.checked)">
                        </p-checkbox>
                        <label for="termsCheckbox" class="terms-label">
                            I have read and agree to the
                            <button type="button"
                                    class="terms-link"
                                    (click)="showTerms()">
                                Terms of Service
                            </button>
                            and
                            <a [href]="privacyUrl" target="_blank" rel="noopener"
                               class="terms-link" (click)="$event.stopPropagation()">Privacy Policy</a>
                        </label>
                    </div>
                </div>

                <amplify-authenticator [initialState]="initialAuthState" [loginMechanisms]="['email']" [formFields]="formFields" [services]="services">
                    <div slot="footer" class="auth-footer-section">
                        <!-- Password Policy Section (Only visible during sign up) -->
                        <div class="password-policy-section" [style.display]="showTermsSection ? 'block' : 'none'">
                            <div class="password-policy-card">
                                <h4 class="policy-title">
                                    <i class="pi pi-shield" style="margin-right: 8px; color: #6366f1;"></i>
                                    Password Requirements
                                </h4>
                                <div class="policy-requirements">
                                    <div class="requirement-item" *ngFor="let requirement of passwordPolicy.requirements"
                                         [class.requirement-met]="requirement.met" [class.requirement-unmet]="!requirement.met">
                                        <i class="pi requirement-icon"
                                           [class.pi-check-circle]="requirement.met"
                                           [class.pi-circle]="!requirement.met"></i>
                                        <span class="requirement-text">{{ requirement.text }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </amplify-authenticator>
            </div>
        </div>

    </div>
</div>

<!-- Terms and Conditions Modal -->
<p-dialog 
    header="Terms of Service"
    [(visible)]="showTermsModal"
    [modal]="true"
    [closable]="true"
    [style]="{width: '90vw', maxWidth: '800px', height: '80vh'}"
    [draggable]="false"
    [resizable]="false"
    styleClass="terms-modal">
    
    <div class="terms-content">
        <div class="terms-text">
            {{ termsAndConditions }}
        </div>
    </div>
    
    <ng-template pTemplate="footer">
        <p-button 
            label="Close" 
            icon="pi pi-times" 
            (onClick)="hideTerms()"
            styleClass="p-button-secondary">
        </p-button>
    </ng-template>
</p-dialog>